import { render } from "./AddPaymentMethod.vue?vue&type=template&id=4519af45&scoped=true"
import script from "./AddPaymentMethod.vue?vue&type=script&lang=js"
export * from "./AddPaymentMethod.vue?vue&type=script&lang=js"

import "./AddPaymentMethod.vue?vue&type=style&index=0&id=4519af45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4519af45"]])

export default __exports__